import { render, staticRenderFns } from "./flotillas.vue?vue&type=template&id=34bbfd1a&scoped=true"
import script from "./flotillas.vue?vue&type=script&lang=js"
export * from "./flotillas.vue?vue&type=script&lang=js"
import style0 from "./flotillas.vue?vue&type=style&index=0&id=34bbfd1a&prod&scoped=true&lang=scss"
import style1 from "./flotillas.vue?vue&type=style&index=1&id=34bbfd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbfd1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,VCarousel: require('/var/www/tubber-new/components/global/v/carousel.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default})
